import BundleProductSpecificationsIdentifier from "../../../constants/BundleProductSpecificationsIdentifier";
import BundleSingleProduct from "../../../entities/manhattan/bundle/BundleSingleProduct";
import { IBundleProductCharacteristic, IBundleSingleProduct } from "../../../entities/manhattan/bundle/types";
import { BundleProductCharacteristicFactory } from "./BundleProductCharacteristicsFactory";

export default class BundleSingleProductFactory {

  static create(bundleSingleProduct: IBundleSingleProduct): BundleSingleProduct {
    return new BundleSingleProduct(
      bundleSingleProduct.id,
      bundleSingleProduct.desc,
      bundleSingleProduct.descEn,
      bundleSingleProduct.groupMaster,
      bundleSingleProduct.label,
      bundleSingleProduct.labelId,
      bundleSingleProduct.manufacturer,
      bundleSingleProduct.model,
      bundleSingleProduct.outlet,
      this.createProductCharacteristics(bundleSingleProduct.productCharacteristics),
      bundleSingleProduct.productColorsImages,
      bundleSingleProduct.productGroupId,
      bundleSingleProduct.productImages,
      bundleSingleProduct.productLine,
      bundleSingleProduct.productPrices,
      bundleSingleProduct.addons,
      bundleSingleProduct.status,
      bundleSingleProduct.statusBusiness,
      {
        [BundleProductSpecificationsIdentifier.SI_INTERNET]: [],
        [BundleProductSpecificationsIdentifier.SI_TV]: [],
        [BundleProductSpecificationsIdentifier.SI_LANDLINE]: [],
      }
    );
  }

  private static createProductCharacteristics (productCharacteristics: IBundleProductCharacteristic[]) {
    const characteristics: IBundleProductCharacteristic[] = [];
    productCharacteristics.forEach((productCharacteristic: IBundleProductCharacteristic) => {
      characteristics.push(BundleProductCharacteristicFactory.create(productCharacteristic));
    });

    return characteristics;
  }

}
